import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

export const SlideBlockContext = React.createContext();

/**
 * SlideBlock
 * The Wrapper component inside which the design-slides are rendered.
 */
export function SlideBlock(props) {
  const setStyle = () => {
    if (props.extend) return {};
    else
      return {
        marginRight: `${props.marginRight}px`,
        width: `calc(100vw - ${props.marginRight + 1}px)`,
      };
  };

  const getTabIndex = () => (props.focused ? '0' : '-1');

  return (
    <div className={style.designView} style={setStyle()}>
      <SlideBlockContext.Provider value={{getTabIndex}}>
        <div className={style.designView_left}>{props.children}</div>
      </SlideBlockContext.Provider>
    </div>
  );
}

SlideBlock.propTypes = {
  /**
   * Componets to be displayed inside SlideBlock
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
  /**
   * Boolean value to set when you want SlideBlock to extend
   * the width of full page
   */
  extend: PropTypes.bool.isRequired,
  /**
   * Margin value to be set at right side [In pixels]
   */
  marginRight: PropTypes.number.isRequired,
  /**
   * Boolean to know if Design View is active/inactive
   * used to activate/deactivate keyboard navigation
   */
  focused: PropTypes.bool,
};

SlideBlock.defaultProps = {
  extend: false,
  marginRight: 382,
  focused: false,
};
